// Hand-written until the OpenAPI types are regenerated.
export type RentAmendmentSide = 'TENANT' | 'LANDLORD'
export type RentAmendmentStatus = 'SENT' | 'SIGNED' | 'APPLIED' | 'CANCELLED'
/**
 * AMENDMENT is signed by every party in DocuSeal. NOTICE is the unilateral
 * written increase the sublease contract allows (Art. IV 9–10) — tenant side
 * only, binding once sent, so it starts as SIGNED. DEPOSIT is a landlord
 * amendment changing only the security deposit; it takes effect on signing.
 */
export type RentAmendmentKind = 'AMENDMENT' | 'NOTICE' | 'DEPOSIT'

export const PRICE_FIELDS = [
  'rent',
  'monthly_advance_prescription',
  'gas',
  'electricity',
  'internet_tv'
] as const

export type PriceField = (typeof PRICE_FIELDS)[number]
export type Prices = Record<PriceField, number>

export type RentAmendmentSigner = {
  id: string
  email: string
  status: string
  name: string
}

export type RentAmendment = Prices & {
  id: string
  side: RentAmendmentSide
  kind: RentAmendmentKind
  offer: string | null
  flat: string | null
  amendment_number: string
  effective_from: string
  status: RentAmendmentStatus
  monthly_payments: number
  previous_rent: number
  previous_monthly_advance_prescription: number
  previous_gas: number
  previous_electricity: number
  previous_internet_tv: number
  previous_monthly_payments: number
  /** Only on kind DEPOSIT. */
  deposit: number | null
  previous_deposit: number | null
  signed_at: string | null
  applied_at: string | null
  skipped_paid_rents: number
  created_at: string
  created_by: string | null
  signers: RentAmendmentSigner[]
}

export type RentAmendmentBody = Prices & {
  side: RentAmendmentSide
  kind: RentAmendmentKind
  offer?: string
  flat?: string
  effective_from: string
}

export type DepositAmendmentBody = {
  flat: string
  deposit: number
}

/** Amounts an amendment replaced, keyed like the new ones. */
export const previousPrices = (a: RentAmendment): Prices => ({
  rent: a.previous_rent,
  monthly_advance_prescription: a.previous_monthly_advance_prescription,
  gas: a.previous_gas,
  electricity: a.previous_electricity,
  internet_tv: a.previous_internet_tv
})

/** Prefilled effective date of a landlord amendment. */
export type LandlordAmendmentDefault = {
  effective_from: string
  /** End of the running sublease the default follows; null without one. */
  tenant_contract_end: string | null
  /** No sublease contract yet — the amendment may start on any day. */
  any_date_allowed: boolean
}
